export  enum RoleType {
    Root = 1,
    Aww = 2,
    Ngo = 3,
    DistrictCollector = 4
}


